import { LOGGER } from "../utils/logger";
import useAxios from "../utils/interceptor";

const RequestDemoApi = () => {
  const axiosHandler = useAxios();

  const getAllPaginated = async ({ page = 0, pageSize = 10, search = "" }) => {
    try {
      const res = await axiosHandler.get(
        `demo-user/all?page=${page}&pageSize=${pageSize}&search=${search}`
      );
      return res?.data?.data;
    } catch (error) {
      LOGGER.error({ text: "getAll api ", error });
    }
  };

  const create = async (body) => {
    try {
      const res = await axiosHandler.post("demo-user", body);
      console.log("...", res);
      return res;
    } catch (error) {
      LOGGER.error({ text: "Create Demo User Api", error });
      return {
        text: "Create Demo User Api",
        error,
      };
    }
  };

  const update = async (body) => {
    try {
      const res = await axiosHandler.post(`demo-user/approve-user`, body);
      return res;
    } catch (error) {
      LOGGER.error({ text: "Update api ", error });
    }
  };

  const remove = async (id) => {
    try {
      const res = await axiosHandler.delete(`demo-user/${id}`);
      return res;
    } catch (error) {
      LOGGER.error({ text: "remove api ", error });
    }
  };

  return { getAllPaginated, create, update, remove };
};

export default RequestDemoApi;
